<template>
      <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
   
      <div class="main_home_content">
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1 pt-5 pb-5">
          <!-- Login Tab Content -->
          <div class="home-content">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-7 col-lg-6">
                <h1 :style="{ marginTop: '20px' }">
                  Easy Access to City-wide Healthcare Practitioners
                </h1>
                <h3 :style="{ marginTop: '20px' }">
                  Discover and Connect with Healthcare Professionals Across the
                  City
                </h3>
                <h5 :style="{ marginTop: '20px' }">
                  {{main_data}} Comprehensive Directory – Your Gateway
                  to Local Medical Expertise
                </h5>
                <p :style="{ marginTop: '20px' }">
                  Choosing the right healthcare professional can be a challenge,
                  especially with so many options available. With {{main_data}}
                   directory, patients can easily search, discover,
                  and connect with qualified healthcare practitioners across the
                  city, ensuring they receive the best care possible.
                </p>
              </div>
              <div class="col-md-12 col-lg-5">
                <img style="height: 360px;"
                  src="@/assets/img/healthcare.jpeg"
                  class="img-fluid"
                  alt="Doccure Login"
                />
              </div>
            </div>
          </div>
          <!-- /Login Tab Content -->
        </div>
      </div>
    </div>
    <!-- Key Feature Section -->
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h2 class="first_section_heading pb-5 pt-5" align="center">
          Key Features
        </h2>
        <b-card-group deck>
          <b-card
            border-variant="dark"
            header="Comprehensive Practitioner Directory"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>An Extensive List at Your Fingertips</h4>
            <b-card-text
              >Browse through a detailed directory of healthcare practitioners
              across various specialties. Whether you're seeking a general
              physician or a specialized surgeon, we have you
              covered.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Detailed Practitioner Profiles"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Know Your Healthcare Professional</h4>
            <b-card-text
              >Each practitioner profile contains detailed darkrmation,
              including qualifications, experience, areas of expertise, patient
              reviews, and more, ensuring you make an darkrmed
              choice.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Location-based Search"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Find Professionals Near You</h4>
            <b-card-text>
              Use the location-based search feature to find healthcare
              practitioners in your vicinity or in a specific part of the
              city.</b-card-text
            >
          </b-card>
        </b-card-group>
        <b-card-group deck style="margin-top: 30px;margin-bottom: 40px;">
          <b-card
            border-variant="dark"
            header=" Easy Appointment Booking"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Connect in Just a Few Clicks</h4>
            <b-card-text
              >Once you've chosen a healthcare practitioner, book an appointment
              directly through the platform, ensuring a hassle-free
              connection.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="User Reviews and Ratings"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Hear from Fellow Patients</h4>
            <b-card-text
              >Read reviews and ratings from other patients to get a better
              understanding of the healthcare practitioner's expertise and
              patient care approach.</b-card-text
            >
          </b-card>
          <b-card style="border: none;"> </b-card>
        </b-card-group>
      </div>
    </div>

    <!-- Benefit Section -->

    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h2
          style="text-align: center; padding-bottom: 20px; margin-top: 30px;margin-bottom: 30px;"
        >
          The Advantages of a City-wide Healthcare Directory
        </h2>
        <b-card-group deck>
          <b-card
            border-variant="dark"
            header="Choice"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Access a wide range of healthcare practitioners, giving you the
              freedom to choose the best fit for your needs.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Convenience"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Discover, research, and connect with healthcare professionals all
              in one place.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Confidence"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text>
              Make darkrmed decisions based on detailed profiles and patient
              reviews.</b-card-text
            >
          </b-card>
        </b-card-group>
        <b-card-group deck style="margin-top: 30px;">
          <b-card
            border-variant="dark"
            header="Accessibility"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Find and book appointments with healthcare practitioners from the
              comfort of your home</b-card-text
            >
          </b-card>
          <b-card style="border: none;"> </b-card>
          <b-card style="border: none;"> </b-card>
        </b-card-group>
        <!--Call Action Section -->
        <div class="mt-5"
          style="display: flex; justify-content: center; align-items: center;"
        >
          <div style="width: 500px; text-align: center;">
            <b-card bg-variant="info" text-variant="white" title="" style="border: 1px solid black;">
              <b-card-text style="text-align: center;">
                Unlock a world of healthcare possibilities with {{main_data}}
                 comprehensive directory. Register today and find
                the right healthcare practitioner for you and your loved ones!
              </b-card-text>
              <b-button href="#" variant="dark" style="text-align: center;">
                Register Now
              </b-button>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>




    <layout-footer></layout-footer>
    </div>
    </div>
  </template>
<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/EasyAccessHealthcarePractice.vue